import commonPostTypeConfig from '../../common/postTypes/video'

export default function initPostType({ wapp }) {
    return wapp.client.postTypes.getPostType({
        name: 'video',
        addIfThereIsNot: true,
        statusManager: commonPostTypeConfig.getStatusManager()
    })
}
